import { PropsWithChildren } from 'react';
import { useInitializationBehaviour } from '../behaviours/useInitializationBehaviour';
import { useTokenRefreshBehaviour } from '../behaviours/useTokenRefreshBehaviour';
import { IdentityConfig, setIdentityConfig } from '../config';

export interface IdentityContextProviderProps {
  config: IdentityConfig;
}

export const IdentityContextProvider = ({ children, config }: PropsWithChildren<IdentityContextProviderProps>) => {
  setIdentityConfig(config);
  useInitializationBehaviour();
  useTokenRefreshBehaviour();

  return children;
};
